import { FetchBase } from '../shared/FetchBase'
import { TierItem } from '../GlobalDataContext'

export class DashboardFetch extends FetchBase {
  constructor() {
    super('', '/api/dashboard')
  }

  dashboardy(): Promise<string> {
    return this.ajaxRequest('GET', 'dashboardy')
  }

  isExportReady(abn: string): Promise<boolean> {
    return this.ajaxRequest('GET', `IsExportReady?abn=${abn}`)
  }

  retrieveTierSettings(): Promise<TierItem[]> {
    return this.ajaxRequest('GET', 'RetrieveTierSettings')
  }

  getHomePageText(): Promise<{ [key: string]: string }> {
    return this.ajaxRequest('GET', 'GetHomePageText')
  }
}
